import React from 'react';
import { Helmet } from 'react-helmet';
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import { helper } from '../../../assets/js/utils/Element.js';
import PropTypes from "prop-types";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import LoaderComponent from '../../components/Loader';
import withStyles from "@material-ui/core/styles/withStyles";
import userSubscriptionPageStyle from "../../../assets/jss/user/userSubscriptionPageStyle.jsx";

const TextractSubscription = class extends React.Component {
    constructor(props){
        super(props);

        this.store = this.props.store;
        this.history = this.props.history;
        const { user } = this.store.getState();

        let status = helper.getParam("state");
        if(status === "null" || !status){
            status = "cancelled";
        }
        let id = helper.getParam("id");
        if(id === "null" || !id){
            id = null;
        }
        let errorMessage = "";
        if(status === "cancelled"){
            errorMessage = "Your subscription failed.";
        }
        this.state = {
            status: status,
            id: id,
            loading: false,
            errorMessage: errorMessage,
            user: user
        };
    }
    componentDidMount(){
        const { status, id } = this.state;
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
            return;
        }
        if(authorized && status !== "cancelled" && id){
            this.checkSubscriptionStatus();
        }
    }
    checkSubscriptionStatus(){
        const source = axios.CancelToken.source();
        const requestData = {
            id: this.state.id
        };
        
        this.setState({
            loading: true,
        });
        
        Api.checkTextractSubscription(requestData, source).then(data => {
            this.history.push("/user/textract/balance");
        }).catch(err => {
            this.setState({
                loading: false, 
                errorMessage: "Your subscription failed."
            });
        });
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<div key={key} className={"form-error-message passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </div>);
                key++;
            }
            return errorMessages;
        }
        return <div className={"form-error-message passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </div>;
    }
    render() {
        const { classes } = this.props;
        const { authorized } = this.store.getState();
        const { loading, errorMessage } = this.state;
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" center"}>
                    {
                        errorMessage !== '' ?
                            this.renderErrorMessages()
                        : loading ?
                            <LoaderComponent color="custom" />
                        :
                            <></>
                    }
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

TextractSubscription.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userSubscriptionPageStyle)(TextractSubscription);
